const origins = [
    {label: "Selecione...", value: ""},
    {label: "Bríndice", value: "Bríndice"},
    {label: "Free Shop", value: "Freeshop"},
    {label: "Prospecção", value: "Prospecção"},
    {label: "Google", value: "Google"},
    {label: "Facebook", value: "Facebook"},
    {label: "Instagram", value: "Instagram"},
    {label: "Linkedin", value: "Linkedin"},
    {label: "Indicação", value: "Indicação"},
    {label: "Outros", value: "Outros"}
];

export default origins;